import React, { useState } from 'react'
import Header from '../components/header'
import { Helmet } from 'react-helmet'
import Footer from '../components/footer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCopy, faTrash } from "@fortawesome/free-solid-svg-icons";
import ParaphraseOutput from '../components/subCmponents/paraphraseOutput';

export default function GrammerFixer() {

    let [show, setShow] = useState(false);
    let [input, setInput] = useState("");
    let [para, setPara] = useState("");

    const cleanJsonString = (str) => {
        if (!str) return '';
        // Remove Markdown code block syntax and any other non-JSON text
        return str.replace(/```json|```/g, '').trim();
    };

    let getData = async () => {
        setPara("");
        const grammerPrompt = `Generate a JSON object that corrects the grammar, punctuation, and spelling errors in the following text while preserving its original meaning. Improve clarity and flow, making the text sound natural and professional: ${input}. Format:
{
  "corrected_text": "She doesn't like the cold weather and prefers sunny days."
}`;
        setShow(true);
        let response = await fetch('https://toolisobackend.vercel.app/grammerFixer', {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ grammerPrompt })
        })
        const data = await response.json();
        if (response.status == 200) {
            const generatedText =
                data?.candidates?.[0]?.content?.parts?.[0]?.text;
            let clearText = cleanJsonString(generatedText);
            const parsed = JSON.parse(clearText);
            setPara(parsed.corrected_text);

        }
        else {
            alert(data.error);

        }
        setShow(false);

    }

    let [copy, setCopy] = useState(false);
    let clearText = () => {
        setInput("");
        setPara("");
    }
    let copyText = () => {
        setCopy(copy = true);
        navigator.clipboard.writeText(para);
        setTimeout(() => {
            setCopy(copy = false);
        }, 2000);
    }

    return (
        <div>
            <Helmet>
                <html lang="en" />
                <title>AI Grammar Fixer – Free Online Grammar & Spell Checker</title>
                <meta
                    name="description"
                    content="Fix grammar, punctuation, and spelling errors instantly with our free AI Grammar Fixer. Perfect for students, professionals, and writers who want polished, error-free content."
                />
                <link rel="canonical" href="https://tooliso.com/GrammarFixerAI" />

                <meta property="og:title" content="AI Grammar Fixer – Free & Instant Proofreading Tool" />
                <meta
                    property="og:description"
                    content="Use Tooliso’s AI Grammar Fixer to correct grammar, spelling, and punctuation mistakes. Fast, accurate, and easy to use – no signup required."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://tooliso.com/GrammarFixerAI" />

                <meta name="twitter:card" content="summary" />
                <meta name="twitter:title" content="Tooliso AI Grammar Fixer – Fix Writing Mistakes Instantly" />
                <meta
                    name="twitter:description"
                    content="Correct grammar, spelling, and punctuation errors in seconds using Tooliso’s AI Grammar Fixer. Ideal for students, bloggers, and professionals."
                />
            </Helmet>
            <Header />

            <div style={{ marginTop: "110px", padding: "2rem" }}>
                <div className="Knowlegdeinput-section">
                    <h2 className="Knowlegdetitle">AI GRAMMER FIXER</h2>
                    <p className="Knowlegdedescription">Paste your text to instantly fix grammar, punctuation, and spelling errors while improving sentence clarity.</p>

                    <textarea id="topicsInput" value={input} onChange={(e) => setInput(input = e.target.value)} placeholder="Paste your text here to fix grammar, punctuation, and spelling errors.
Example:
- she dont like the cold weather.
- the results is not accurate.
- this sentence needs revised, isn't it?
..."></textarea>

                    {
                        show ?
                            <div className="outerspin">
                                <div className='spinner'></div>
                            </div>
                            :
                            input == "" ?
                                <button id="generateBtn" className="Knowledgebtn nopoint">
                                    Fix Now
                                </button>
                                :
                                <button id="generateBtn" onClick={getData} className="Knowledgebtn point">
                                    Fix Now
                                </button>
                    }


                    {
                        para == "" ? "" :
                            <>
                                <ParaphraseOutput text={para} />
                                <div className="copyCounter">
                                    <button className='clearBtn' onClick={clearText}><FontAwesomeIcon icon={faTrash} />Clear Text</button>
                                    {
                                        copy ?
                                            <button className='copyBtn'><FontAwesomeIcon icon={faCheck} />Text Copied</button>
                                            :
                                            <button className='copyBtn' onClick={copyText}><FontAwesomeIcon icon={faCopy} />Copy Text</button>
                                    }
                                </div>
                            </>


                    }
                </div>
            </div>
            <Footer />
        </div>
    )
}
